import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBQ4ZQA1s0C9j0oeBA7y2oxwlaU5wqeS2U",
  authDomain: "hattravel-35f15.firebaseapp.com",
  databaseURL: "https://hattravel-35f15-default-rtdb.firebaseio.com",
  projectId: "hattravel-35f15",
  storageBucket: "hattravel-35f15.firebasestorage.app",
  messagingSenderId: "22807714204",
  appId: "1:22807714204:web:b97d39660af33b2b70d059"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app; 